import React, { useState, useEffect, useRef } from "react";
// import FridLogo from "../assets/FridLogo.png";
import no_image from "../assets/no_image.png";
import Compétences from "../assets/Compétences.svg";
import { FiMapPin } from "react-icons/fi";
import messages from "../assets/messages.svg";
import akarIconsCalendar from "../assets/akar-icons_calendar.svg";
import tel from "../assets/tel.svg";
import ReactPaginate from "react-paginate";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import searchIcon from "../assets/search.svg";
import Footer from "../component/Footer";
import { useParams } from "react-router-dom";
import axios from "axios";
import Mapbox from "../component/mapbox/Mapbox";
import {getLatLngFromAddress} from "../component/mapbox/Mapbox";
import MessageProFormComp from "../component/messageProForm";
import PageLoaderComp from "../component/pageLoaderComp";

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { decodedStringValue } from "../_helpers";
import Breadcrumb from "./Directory/Breadcrumb";
import ToastMessageComp from "../component/ToastMessageComp";
import { useSelector } from "react-redux";

import VerifiedIcon from '@mui/icons-material/Verified';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];
export default function DirectoryOfAvocats() {
  const alert = useSelector(state => state.alert);
  const { city, postalCode } = useParams();
  const [data, setData] = useState([]);
  const [successfull, setSuccessfull] = useState(false);
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemPerPage, setItemPerPage] = useState(100);
  const [loadingFullpage, setLoadingFullpage] = useState(false);
  const [selectedFilterData, setSelectedFilterData] = useState( { "domaines":[] ,"specialisations": [] , "langues":[],"accessibilites":[] }
  );
  const [filterData, setFilterData] = useState({
    "domaines":[
      {value :"Droit de l'entreprise"},{value :"Droit des entreprises"},{value :"Contentieux fiscal"},{value :"Contentieux pénal"},{value :"Droit du numérique"},{value :"Droit de la propriété industrielle"},{value :"Droit de la propriété intellectuelle"},{value :"Droit de l'informatique"},{value :"Droit des sociétés"},{value :"Droit industriel"},{value :"Droit commercial"},{value :"Droit des contrats"},{value :"Droit commercial international"},{value :"Droit international"},{value :"Droit des faillites"},{value :"Droit de successions"},{value :"Droit de domaine"},{value :"Droit de la concurrence déloyale"},{value :"Droit des marques"},{value :"Droit des marchés publics"},{value :"Droit de l'investissement"},{value :"Droit fiscal"},{value :"Droit foncier"},{value :"Fiscalité personnelle"},{value :"Droit des médias et nouvelles technologies"},{value :"Droit des nouvelles technologies"},{value :"Droit du travail"},{value :"Droit de créance"},{value :"Droit immobilier"},{value :"Droit de bail"},{value :"Droit boursier"},{value :"Droit de la distribution"},{value :"Droit du sport"},{value :"Droit de la Sécurité Sociale"},{value :"Droit des étrangers et de la nationalité"},{value :"Droit médical"},{value :"Droit des contrats de licence"},{value :"Droit des victimes"},{value :"Droit du dommage corporel"},{value :"Droit de visite et d'herbergement"},{value :"Droit des infractions administratives"},{value :"Droit alimentaire"},{value :"Droit des procédures collectives"},{value :"Droit scolaire"},{value :"Droit matrimonial"},{value :"Droit de l'architecture"},{value :"Droit de l'insolvabilité des consommateurs"},{value :"Droit de la presse"},{value :"Droit de la concurrence"},{value :"Droit de la protection des données personnelles"},{value :"Droit du paiement"},{value :"Droit du transport aérien"},{value :"Droit des garanties "},{value :"Droit minier"},{value :"Droit de la construction publique"},{value :"Droit public"},{value :"Droit de donation"},{value :"Droit d'enregistrement"},{value :"Droit de la construction"},{value :"Droit de l'urbanisme"},{value :"Droit des transports"},{value :"Droit de la fonction publique"},{value :"Droit de la responsabilité"},{value :"Droit équin"},{value :"Droit de la Sécurité Sociale"},{value :"Droit syndical"},{value :"Droit routier"},{value :"Droit maritime"},{value :"Droit des assurances"},{value :"Droit bancaire"},{value :"Droit de voisinage en matière de construction"},{value :"Droit de la santé"},{value :"Droits de l'homme et des libertés publiques"},{value :"Droit de la chasse"},{value :"Droit des collectivités locales"},{value :"Droit de l'environnement"},{value :"Droit de roulage et permis de conduire"},{value :"Droit constitutionnel"},{value :"Droit administratif"},{value :"Droit de la publicité"},{value :"Droit de garde"},{value :"Droit de la fonction publique"},{value :"Droit ordinal"},{value :"Droit des personnes"},{value :"Droit de la famille"},{value :"Droit des obligations"},{value :"Droit patrimonial"},{value :"Droit des affaires"},{value :"Droit de la police"},{value :"Droit rural"},{value :"Droit social"},{value :"Droit pénal"},{value :"Droit civil"},{value :"Droit de la vigne et du vin"},{value :"Droit des tutelles"},{value :"Droit des mineurs"},{value :"Droit du Handicap"},{value :"Droit des voies d'exécution"},{value :"Droit du divorce"},{value :"Droit de la consommation"},{value :"Droit de redondance"},{value :"Ingénierie patrimoniale"}
    ],
    "specialisations":[
      {"value":`Abus de biens sociaux`},{"value":`Abus de faiblesse`},{"value":`Accident`},{"value":`Contentieux pénal`},{"value":`Accident cycliste`},{"value":`Accident de la route - circulation`},{"value":`Accident de trottinette`},{"value":`Accident du travail`},{"value":`Accident piéton`},{"value":`Accords collectifs`},{"value":`Accords de Performance Collective (APC)`},{"value":`Accountability`},{"value":`Actes juridiques`},{"value":`Actions gratuites`},{"value":`Administration de biens`},{"value":`Administration de biens - protection judiciaire`},{"value":`Adoption`},{"value":`Agent administratif`},{"value":`Agent commercial`},{"value":`Agressions`},{"value":`Aide juridictionnelle`},{"value":`AIPD`},{"value":`Alcoolémie au volant`},{"value":`Aléa thérapeutique`},{"value":`Allocation d'enfant handicapé`},{"value":`Aménagement de peine`},{"value":`Aménagement du territoire`},{"value":`Analyse d'impact`},{"value":`Animalier`},{"value":`Annulation permis de conduire`},{"value":`Anonymisation des données`},{"value":`Apatride`},{"value":`Apports cessions`},{"value":`Apports de titres`},{"value":`Arbitrage`},{"value":`Arbitrage international`},{"value":`Architecte`},{"value":`Art`},{"value":`Artiste interprète`},{"value":`Asile`},{"value":`Assemblée générale`},{"value":`Assignation à résidence`},{"value":`Assistance éducative`},{"value":`Associations et fondations`},{"value":`Assurances`},{"value":`Audit`},{"value":`Audit de traitement`},{"value":`Audit social`},{"value":`Automobile`},{"value":`Autorisation de travail`},{"value":`Autorité parentale`},{"value":`Avertissement`},{"value":`Bail`},{"value":`Bail à ferme`},{"value":`Bancaire`},{"value":`Bancaire et boursier`},{"value":`Base de données`},{"value":`Base de Donnés Economiques et Sociales (BDES)`},{"value":`Baux`},{"value":`Baux commerciaux`},{"value":`Baux d'habitation`},{"value":`Beatmaker`},{"value":`Biens`},{"value":`Binding corporate rules`},{"value":`Blanchiment`},{"value":`Blessures`},{"value":`Bloctel`},{"value":`Brevet`},{"value":`BSA`},{"value":`BSA AIR`},{"value":`BSPCE`},{"value":`Carte de résident`},{"value":`Cartographie des traitements`},{"value":`Cautionnement`},{"value":`CCI ONIAM`},{"value":`CEPD`},{"value":`Certificat de travail`},{"value":`Cessions-acquisitions de sociétés - fonds de commerce`},{"value":`CGU`},{"value":`CGV`},{"value":`Changement des opérations`},{"value":`Chasse`},{"value":`Chômage partiel`},{"value":`Chômeurs`},{"value":`CIL`},{"value":`CIR`},{"value":`Circulation`},{"value":`Clause de confidentialité`},{"value":`Clause de non-concurrence`},{"value":`Clauses contractuelles standards`},{"value":`Clauses contractuelles types`},{"value":`CNF`},{"value":`CNIL`},{"value":`Code de conduite`},{"value":`Collecte de données`},{"value":`Collectivités locales`},{"value":`Comité européen des données`},{"value":`Comité Social et Economique (CSE)`},{"value":`Commande publique`},{"value":`Commerce`},{"value":`Commission disciplinaire`},{"value":`Commodités`},{"value":`Compliance`},{"value":`Compositeur`},{"value":`Conciliation`},{"value":`Concubinage`},{"value":`Concurrence déloyale`},{"value":`Confidentialité`},{"value":`Conflit de voisinage`},{"value":`Conflits collectifs du travail`},{"value":`Conflits entre associés`},{"value":`Conformité`},{"value":`Conformité de site`},{"value":`Congés`},{"value":`Conseil`},{"value":`Conseil contentieux`},{"value":`Conseil d'Etat`},{"value":`Conseil prud'hommes`},{"value":`Consentement mutuel`},{"value":`Construction`},{"value":`Contentieux`},{"value":`Contestation de licenciement`},{"value":`Contestation paternité`},{"value":`Contestation saisie immobilière et hypothèque`},{"value":`Contrat de mariage`},{"value":`Contrat de responsabilité conjointe`},{"value":`Contrat de travail`},{"value":`Contrats`},{"value":`Contrats commerciaux`},{"value":`Contrats de construction`},{"value":`Contrats informatiques`},{"value":`Contrefaçon`},{"value":`Contrôle CNIL`},{"value":`Contrôle fiscal`},{"value":`Conventions fiscales internationales`},{"value":`Cookies`},{"value":`Copropriété`},{"value":`Correspondant informatique et libertés`},{"value":`Cour de cassation`},{"value":`Cour Européenne des Droit de l'Homme`},{"value":`Création d'entreprise`},{"value":`Crédit d'impôt recherche`},{"value":`Crédits à la consommation`},{"value":`Crime`},{"value":`Cyberharcèlement`},{"value":`Cybersécurité`},{"value":`DALO`},{"value":`Data protection agreement`},{"value":`Data subject`},{"value":`Décès`},{"value":`Déclaration de TVA`},{"value":`Déclaration d'impôts sur le revenu`},{"value":`Déclarations`},{"value":`Dédommagement`},{"value":`Délégués syndicaux`},{"value":`Délit`},{"value":`Démembrement de propriété`},{"value":`Designs`},{"value":`Dessin et modèle`},{"value":`Diffamation`},{"value":`Divorce`},{"value":`Divorce en ligne`},{"value":`Divorce par consentement mutuel`},{"value":`Dommage et préjudice corporel`},{"value":`Donation`},{"value":`Données particulières`},{"value":`Données personnelles`},{"value":`Données sensibles`},{"value":`Douanier`},{"value":`DPD`},{"value":`DPO`},{"value":`DPO externalisé`},{"value":`Droit à la portabilité`},{"value":`Droit à l'oubli`},{"value":`Droit d'accès`},{"value":`Droit de l'audiovisuel`},{"value":`Droit de passage - servitude`},{"value":`Droit de rectification`},{"value":`Droit d'effacement`},{"value":`Droit des brevets`},{"value":`Droit du travail`},{"value":`Droits d'auteur`},{"value":`Durée de conservation`},{"value":`E-commerce`},{"value":`Economie d'impôts`},{"value":`Editeur d'œuvres musicales`},{"value":`Egalité professionnelle Hommes-Femmes`},{"value":`Emprunts bancaires`},{"value":`Enchères`},{"value":`Entreprises`},{"value":`Entreprises en difficultés`},{"value":`Environnement`},{"value":`Equidé`},{"value":`Erreurs médicales`},{"value":`Escroquerie`},{"value":`Expertise`},{"value":`Expertise judiciaire`},{"value":`Expropriation`},{"value":`Faillites et entreprises en difficultés`},{"value":`Faute grave`},{"value":`Faute médicale`},{"value":`Filiation`},{"value":`Finalité de traitement`},{"value":`Financement`},{"value":`Fiscalité des sociétés`},{"value":`Fiscalité immobilière`},{"value":`Fiscalité internationale`},{"value":`Fixation de loyers`},{"value":`Fonction publique`},{"value":`Fonds de commerce`},{"value":`Fraude et falsification`},{"value":`Fraude fiscale`},{"value":`Funéraire`},{"value":`Fusions et acquisitions`},{"value":`G29`},{"value":`Garantie accident de la vie`},{"value":`Garantie accident domestique`},{"value":`Garde à vue`},{"value":`Garde enfants`},{"value":`GDPR`},{"value":`Gel des avoirs`},{"value":`Gestion contractuelle`},{"value":`Gestion des cookies`},{"value":`Hacking`},{"value":`Hameçonnage`},{"value":`Handicap`},{"value":`Harcèlement`},{"value":`Harcèlement au travail`},{"value":`Héritage - transmission de biens`},{"value":`Holding`},{"value":`Holding animatrice`},{"value":`ICO`},{"value":`Immobilier`},{"value":`Impôt sur la fortune immobilière`},{"value":`Impôts`},{"value":`Impôts locaux`},{"value":`Impôts sur le revenu`},{"value":`Impôts sur les sociétés`},{"value":`Inaptitude au travail`},{"value":`Indemnisation assurance`},{"value":`Indemnisation contamination amiante`},{"value":`Indemnisation du préjudice`},{"value":`Indemnité d'éviction`},{"value":`Industriel`},{"value":`Infection nosocomiale`},{"value":`Infractions au code de la route`},{"value":`Injonction de payer`},{"value":`Innovation`},{"value":`Insuffisance professionnelle`},{"value":`Intéressement - Participation`},{"value":`Intrapreneuriat`},{"value":`Invalidité-incapacité`},{"value":`Investissement`},{"value":`ISF-IFI`},{"value":`Jeunesse`},{"value":`Jeux`},{"value":`Joint-venture`},{"value":`Juridique des sociétés`},{"value":`Jurisprudence`},{"value":`LBO`},{"value":`Levée de fonds`},{"value":`LGBT`},{"value":`Licenciement`},{"value":`LIL`},{"value":`Liquidation d'actifs`},{"value":`Liquidation du régime matrimonial`},{"value":`Liquidations et partage de communauté`},{"value":`Litige`},{"value":`Litige entre associés`},{"value":`Locatif`},{"value":`Location meublée`},{"value":`Location-gérance`},{"value":`Loi informatique et libertés`},{"value":`Loi nouvelles technologies`},{"value":`Loi SAPIN`},{"value":`Loueur en meublé non professionnel (LMNP)`},{"value":`Loyers impayés`},{"value":`Lutte anti-blanchiment`},{"value":`Maladie professionnelle`},{"value":`Maltraitance`},{"value":`Management package`},{"value":`Mandat AD HOC`},{"value":`Mandataire immobilier`},{"value":`Mandataire sportif`},{"value":`Marchés publics`},{"value":`Mariage`},{"value":`Marketing`},{"value":`Marketplace`},{"value":`Marques`},{"value":`Médiation`},{"value":`Mémoire de réclamation`},{"value":`Mer et littoral`},{"value":`Mesures d'exécution`},{"value":`Mobilités`},{"value":`Modèles déposés`},{"value":`Nationalité`},{"value":`Naturalisation`},{"value":`Négociation`},{"value":`Négociation Collective Obligatoire`},{"value":`Notarial`},{"value":`Numérique`},{"value":`Objets connectés`},{"value":`Opt in`},{"value":`Opt out`},{"value":`OQTF`},{"value":`PACS`},{"value":`Pacte d'actionnaires`},{"value":`Pacte Dutreil`},{"value":`Pacte entre associés`},{"value":`Paie`},{"value":`Paie, recrutement, formation, conseil RH`},{"value":`Paiement`},{"value":`Parolier`},{"value":`Partage`},{"value":`Partie civile`},{"value":`Patrimoine`},{"value":`PCH`},{"value":`Pénal (travail)`},{"value":`Pénal de la famille`},{"value":`Pénal des affaires`},{"value":`Pénal des entreprises`},{"value":`Pénal international`},{"value":`Pénalités financières`},{"value":`Pension`},{"value":`Pension alimentaire - garde`},{"value":`Permis de conduire`},{"value":`Perte de chance`},{"value":`Perte d'exploitation restaurant`},{"value":`Pharmaceutique`},{"value":`PIA`},{"value":`Piratage`},{"value":`Plan local d'urbanisme (PLU)`},{"value":`Planification fiscale`},{"value":`Plans de Sauvegarde de l'Emploi (PSE)`},{"value":`Plateforme en ligne`},{"value":`Pôle social`},{"value":`Pôle social MDPH`},{"value":`Police`},{"value":`Portage salarial`},{"value":`Préjudice moral et financier`},{"value":`Presse`},{"value":`Prêt bancaire`},{"value":`Prévention des risques`},{"value":`Prévoyance`},{"value":`Procédure administrative`},{"value":`Procédure d'admission`},{"value":`Procédure d'appel`},{"value":`Procédure d'enregistrement`},{"value":`Procédures collectives`},{"value":`Procédures d'expulsions`},{"value":`Procréation médicalement assistée (PMA)`},{"value":`Producteur de phonogrammes`},{"value":`Projets digitaux`},{"value":`Proposition de rectification`},{"value":`Propriété industrielle`},{"value":`Propriété intellectuelle`},{"value":`Propriété littéraire et artistique`},{"value":`Protection contre le licenciement`},{"value":`Protection de la propriété industrielle`},{"value":`Protection des dessins et modèles`},{"value":`Protection des données`},{"value":`Protection du savoir faire`},{"value":`Protection du savoir-faire - innovation`},{"value":`Protection juridique`},{"value":`Protection sociale`},{"value":`Pseudonymisation des données`},{"value":`Publicité ciblée`},{"value":`PV d'Assemblée Générale`},{"value":`Qualité de Vie au Travail (QVT)`},{"value":`Ransomware`},{"value":`Réalisateur artistique`},{"value":`Reconnaissance de paternité`},{"value":`Recours en indemnisation`},{"value":`Recouvrement de créances`},{"value":`Recueil de consentement`},{"value":`Rédaction des contrats et statuts`},{"value":`Redressement judiciaire`},{"value":`Refus de visa`},{"value":`Registre du traitement`},{"value":`Règlement des sinistres`},{"value":`Règlement intérieur`},{"value":`Règlementation étiquetage`},{"value":`Règles contraignantes d'entreprise`},{"value":`Regroupement familial`},{"value":`Régularisation`},{"value":`Renouvellement bail`},{"value":`Réparation des préjudices`},{"value":`Représentation du personnel`},{"value":`Résiliation bail`},{"value":`Responsabilité administrative`},{"value":`Responsabilité civile`},{"value":`Responsabilité du dirigeant`},{"value":`Responsabilité médicale et indemnisation`},{"value":`Responsabilité patrimoniale de l'administration`},{"value":`Responsable du traitement`},{"value":`Restructuration`},{"value":`Retrait de naturalisation`},{"value":`Retrait de visa`},{"value":`Retraite`},{"value":`RGPD`},{"value":`Risque`},{"value":`Risques Psychosociaux (RPS)`},{"value":`Routier`},{"value":`RSE`},{"value":`Rupture conventionnelle`},{"value":`Rupture conventionnelle fonction publique`},{"value":`Rupture de relations commerciales`},{"value":`Saisie`},{"value":`Saisie immobilière`},{"value":`Salaire`},{"value":`Salarié protégé`},{"value":`Sanctions disciplinaires`},{"value":`Sanctions financières`},{"value":`Sauvegarde`},{"value":`Secrétariat juridique`},{"value":`Sécurisation`},{"value":`Sécurité des données`},{"value":`Sécurité sociale`},{"value":`Séparation de biens`},{"value":`Séparation des parents`},{"value":`Sous-traitant`},{"value":`Sponsoring`},{"value":`Sport`},{"value":`Statut`},{"value":`Statut auto-entrepreneur`},{"value":`Stock-options`},{"value":`Stupéfiants`},{"value":`Successions`},{"value":`Surendettement`},{"value":`Télétravail`},{"value":`Testament`},{"value":`Titre de séjour`},{"value":`Topliner`},{"value":`Traceurs`},{"value":`Tracking`},{"value":`Traitement de données`},{"value":`Transferts d'entreprise`},{"value":`Transport aérien`},{"value":`Travail dissimulé`},{"value":`Travaux`},{"value":`Tribunal correctionnel`},{"value":`Tribunal pour enfant`},{"value":`Trouble DYS`},{"value":`Troubles du voisinage`},{"value":`Tutelle`},{"value":`TVA`},{"value":`Urbanisme`},{"value":`URSSAF`},{"value":`Usuraire`},{"value":`Usure`},{"value":`Vente aux enchères`},{"value":`Ventes et transactions immobilières`},{"value":`Vices cachés`},{"value":`Vices de construction et malfaçons`},{"value":`Victimes`},{"value":`Victimes de l'amiante`},{"value":`Vidéoprotection`},{"value":`Viol`},{"value":`Violation de données`},{"value":`Violation de sécurité`},{"value":`Violence contre les mineurs`},{"value":`Violences`},{"value":`Visa`},{"value":`Vitriolage`}
     
  ],
    "langues":[ 
      {value :"Français"},
      {value :"Anglais"},
      {value :"Allemand"},
      {value :"Arabe"},
      {value :"Italien"},
      {value :"Chinois"},
      {value :"Hébreu"},
      {value :"Espagnol"},
      {value :"Portugais"},
      {value :"Russe"},
    ],
    "accessibilites":[
      {value :"Accès personne handicapée"},
      {value :"Ascenseur"},
      {value :"Parking"},
    ],
  });
  const [paginateData, setPaginateData] = useState({
    "current": 1,
    "total_pages": 0,
    "total_results": 0,
    "size": 100
  });
  const [geoJson, setGeoJson] = useState({
    "type": "FeatureCollection",
    "features": []
  });
  const [latlng, setLatlng] = useState({
    "latitude":48.864716,
    "longitude":2.349014,
  });
  const [breadcrumbsData, setBreadcrumbsData] = useState({
    "breadCrumbs":[
      {"pagename":"Avocats","path":"/avocats"}
    ],
    "main":{"pagename":postalCode,"path":"/"}
  });
  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    // setPageCount(Math.ceil(data.length / itemPerPage));
    setPageCount(Math.ceil(paginateData.total_results / itemPerPage))
  }, [postalCode, itemOffset, data,paginateData]);
  // Use Effect
  useEffect(() => {
    setBreadcrumbsData({
      "breadCrumbs":[
        {"pagename":"Avocats","path":"/avocats"}
      ],
      "main":{"pagename":postalCode,"path":"/"}
    })
    setLoadingFullpage(true);
    // let URL = process.env.REACT_APP_API_URL + "api/admin/get_directive_avocats";
    let URL = process.env.REACT_APP_API_URL + "api/admin/search_directive_avocats";
    
    let data = { search: postalCode,size:paginateData.size,currentPage:paginateData.current };


    // let URL = `https://enterprise-search.kifwat.net/api/as/v1/engines/directory-avocats/search`;

    // let data = JSON.stringify({
    //   "query": postalCode,
    //   /* "group": {
    //     "field": "code_postal"
    //   } */
    // });
    let config = {
      method: "post",
      url: URL,
      data: data,
      headers: {
        // 'Authorization': `Bearer ${process.env.REACT_APP_ELK_SEARCH_API_KEY}`,
        // 'Accept': '*/*', 
        // "Cache-Control":"no-cache",
        'Content-Type': 'application/json',
      },
    };

    axios
      .request(config)
      .then(async(response) => {
        
        // console.log(response.data);
        if(response.data && response.data.data && response.data.data.length>0){
          let jsonData = [];
          await Promise.all(response.data.data.map(async(valdata,key)=>{
            let val = valdata._source;
            // console.log("val._source.cbAdresse1",val._source.cbAdresse1)
            try {
              const responseAddress = await getLatLngFromAddress(val.cbAdresse1);
              // console.log("responseAddress",responseAddress)
              if(responseAddress && responseAddress.features.length>0){
                let filterData  = responseAddress.features.filter((Filterval,i)=>Filterval.place_name.includes(val.cbCp))
                // console.log("filterData",filterData);
                if(filterData.length>0){
                  jsonData.push({
                    "type": "Feature",
                    "geometry": filterData[0].geometry
                  })
                  setLatlng({
                    "latitude":filterData[0].geometry.coordinates[1],
                    "longitude":filterData[0].geometry.coordinates[0],
                  })
                }
              }  
            } catch (err) {
              // throw new Error('Unable to establish a login session.');
            }
                      
          }))
          // console.log("jsonData",jsonData);
          setGeoJson({
            "type": "FeatureCollection",
            "features": jsonData
          });
        }
        setData(response.data.data);
        setPaginateData(response.data.paginateResult);
        setLoadingFullpage(false);
      })
      .catch((error) => {
        setLoadingFullpage(false);
        console.log(error);
      });

  }, [postalCode]);
  // ======================================getSearchResult
const getSearchResult=(currentPage)=>{
  setLoadingFullpage(true);
  // let URL = process.env.REACT_APP_API_URL + "api/admin/get_directive_avocats";
  let URL = process.env.REACT_APP_API_URL + "api/admin/search_directive_avocats";
    
  let data = { search: postalCode,size:paginateData.size,currentPage:currentPage };

  let config = {
    method: "post",
    url: URL,
    data: data,
    headers: { 
      // 'Authorization': `Bearer ${process.env.REACT_APP_ELK_SEARCH_API_KEY}`,
      // 'Accept': '*/*', 
      // "Cache-Control":"no-cache",
      'Content-Type': 'application/json', 
    },
  };

  axios
    .request(config)
    .then((response) => {
      setLoadingFullpage(false);
      // console.log(response.data);
      setData(response.data.data);
      setPaginateData(response.data.paginateResult);
    })
    .catch((error) => {
      setLoadingFullpage(false);
      console.log(error);
    });
}

  // ====================================
  const [deCriteres, setDeCriteres] = useState(true);
  const onClick = () => {
    setDeCriteres(!deCriteres);
  };
  // ================================================
  /* =====================|Get Default Values|================== */
  const searchRef = useRef(null);
  const [search, setSearch] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  // Search Input data
  function getInputSearchData(input) {
    setSearchKey(input);
    if (input) {
      /* let data = JSON.stringify({
        "query": input,
        "group": {
          "field": "cbCp"
        }
      }); */
      
      let data = { search: input,size:10,currentPage:1 };
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        // url: 'https://enterprise-search.kifwat.net/api/as/v1/engines/directory-avocats/search',
        url: process.env.REACT_APP_API_URL + `api/admin/search_directive_avocats`,
        headers: {
          // 'Authorization': `Bearer ${process.env.REACT_APP_ELK_SEARCH_API_KEY}`,
          // 'Accept': '*/*', 
          // "Cache-Control":"no-cache",
          'Content-Type': 'application/json',
        },
        data: data
      };
      axios.request(config)
        .then((response) => {
          if ((response.data.data).length > 0) {
            let resultList = response.data.data.filter((val, i) => val._source.cbVille && val._source.cbCp)            
            setSearch(resultList);
            setCheckList(true);

          } else {
            setSearch(response.data.data);
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the request
          console.error(error);
          setCheckList(false);
        });
      
    } else {
      setCheckList(false);
    }
  }
  // ========================================
  const [checkList, setCheckList] = useState(false);
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [search, checkList]);

  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setCheckList(false);
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const [singleList, setSingleList] = useState(null);

  const handleOpenMessage = (event,list) => {
    // console.log("handleOpenMessage")
    setIsOpen(true)
    setSingleList(list)
  };
  // ==================filter==========================

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedFilterData({...selectedFilterData,
      name:typeof value === 'string' ? value.split(',') : value,
    })
    
  };
  // ======================|pagination|=========================
  function Items({ currentItems }) {
    return (
      <div className="items mb-2">
        {currentItems &&
          currentItems.map((listData) => {
            let list = listData._source;
            let cleanedStr = "";
            let array = [];
            let url = no_image;
            if (list.logo && list.logo) {
              cleanedStr = list.logo.replace(/^\[('|")?|('|")?\]$/g, "");
              array = cleanedStr.split(",");
              url = array[0].trim();
            }

            return (
              <div className="btnShadow lg:max-w-[723px] w-full h-auto py-8 px-4 bg-white rounded-[21px] mt-8">
                <Link
                  to={"/fiche-avocats/"+ decodedStringValue(list.cbvilleLowerCase)+"/" + list.avocats_id}
                  className="flex sm:flex-row flex-col items-center gap-4"
                >
                  <img src={url} alt={url} style={{"width":"80px"}} />
                  <div className="flex items-start sm:flex-row flex-col justify-between w-full">
                    <div>
                     {/*  <h4 className="font-bold text-lg 3xl:text-xl text-primary">
                        {list.avnom} {list.avprenom}
                      </h4> */}
                      <h6 className="text-base font-semibold text-primary">
                        {decodedStringValue(list.avNom)} {decodedStringValue(list.avPrenom)}
                        {
                          list.partner_status ==="approved"?
                          <span style={{ color: "green", marginLeft: "8px" }}><VerifiedIcon color="success" /></span>
                          : list.partner_status ==="gold" ?<span style={{ color: "green", marginLeft: "8px" }}><VerifiedIcon style={{"color":"gold"}}  /></span>:""
                        }
                      </h6>
                      <p className="text-base font-light text-primary">
                          Avocat
                      </p>
                    </div>

                    <div className="flex whitespace-nowrap items-center gap-1 mt-4 sm:my-0">
                      <FiMapPin />
                      <p>
                      {list.cbCp}, {decodedStringValue(list.cbVille)}
                      </p>
                    </div>
                  </div>
                </Link>

                <hr className="my-6 border-black-light opacity-50" />
                {/* display when compleete his form */}
                <div>
                  <div className="flex gap-2 mt-4">
                    <img src={Compétences} alt="" />
                    <p className="text-base font-normal text-primary">
                      Domaines
                    </p>
                  </div>
                  <div className="mt-4 flex gap-2 items-center flex-wrap  ">
                    {/* <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      Droit des contrats et des biens{" "}
                    </div>
                    
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      + 5
                    </div> */}
                  </div>
                </div>

                <div className="mt-8">
                  <div className="flex gap-2 mt-4">
                    <img src={Compétences} alt="" />
                    <p className="text-base font-normal text-primary">
                      Spécialisations
                    </p>
                  </div>
                  <div className="mt-4 flex gap-2 items-center flex-wrap">
                    {/* <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      Accident du travail{" "}
                    </div>
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      Contentieux pénal{" "}
                    </div>
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      Cyberharcèlement
                    </div>
                    
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      + 3
                    </div> */}
                  </div>
                </div>

                <div className="flex justify-between items-center mt-8 gap-1 sm:gap-4">
                  <button className="w-full max-w-[252px] h-full min-h-[30px] sm:min-h-[50px] flex items-center justify-center gap-1 sm:gap-3 bg-primary text-white  text-xs sm:text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary" onClick={(e)=>handleOpenMessage(e,list)}>
                    <img
                      src={messages}
                      alt="messages"
                      className="w-4 h-4 sm:w-auto sm:h-auto"
                    />
                    Message
                  </button>
                  <button className="w-full max-w-[252px] h-full  min-h-[30px] sm:min-h-[50px] flex items-center justify-center gap-1 sm:gap-3 bg-primary text-white text-xs sm:text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary">
                    <img
                      src={tel}
                      alt="messages"
                      className="w-4 h-4 sm:w-auto sm:h-auto rotate_telephone"
                    />
                    Contacter
                  </button>
                  {/* <button className="w-full max-w-[252px] h-full  min-h-[30px] sm:min-h-[50px] flex items-center justify-center gap-1 sm:gap-3 bg-primary text-white text-xs sm:text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary">
                    <img
                      src={akarIconsCalendar}
                      alt="akarIconsCalendar"
                      className="w-4 h-4 sm:w-auto sm:h-auto"
                    />
                    Prendre RDV
                  </button> */}
                </div>
              </div>
            );
          })}
      </div>
    );
  }

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * 4) % data.length;
    setItemOffset(newOffset);
    setPaginateData(paginateData => ({ ...paginateData, ["current"]: event.selected+1 }));
    getSearchResult(event.selected+1 );
    /* setPaginateData({
      "current": event.selected+1,
      "total_pages": 0,
      "total_results": 0,
      "size": 10
    }) */
  };
  return (
    <>
      <MessageProFormComp isOpen={isOpen} setSuccessfull={setSuccessfull} setIsOpen={setIsOpen} singleList={singleList} type={"avocats"} />
      {loadingFullpage?
      <PageLoaderComp />
      :""}
      {successfull?
        <ToastMessageComp  message={alert.message} type={alert.type} />
        :""}
     <div className='md:max-w-[1200px] relative w-full h-full m-auto py-7 px-4 sm:px-4'>
       <div className="flex items-center justify-start sm:gap-4 w-full m-auto">
          <Breadcrumb page="Experts-comptables" breadcrumbsData={breadcrumbsData} />
        </div>
        <div
          style={{
            position: "relative",
          }}
        >
          <form
            id="searchForm"
            className="bg-white border-0 max-w-[727px] sm:mx-auto my-6 px-5 py-3 sm:py-6 input-box-shadow rounded flex justify-between w-full"
            style={{ boxShadow: "0px 2px 12px rgba(83, 83, 83, 0.25)" ,zIndex:"9" }}
          >
            <input
              type="text"
              onInput={(e) => getInputSearchData(e.target.value)}
              defaultValue={postalCode}
              className=" w-full outline-none text-[#797979] text-base font-light"
              placeholder="Nom de la ville ou du département"
            />
            <button>
              <img src={searchIcon} alt="searchIcon" />
            </button>
          </form>
          <div
            style={{
              display: checkList ? "block" : "none",
              left: "0",
              right: "0",
              top: "80px",zIndex:"9"
            }}
            className="searchListBox max-w-[727px] sm:mx-auto "
            ref={searchRef}
          >
            <ul>
              {search.length === 0 ? (
                <div
                  className="containertype"
                  style={{ textAlign: "left",padding: "9px 19px"}}
                  >
                    <span>No search result found!</span>
                    {/* <div className="dottype"></div>
                    <div className="dottype"></div>
                    <div className="dottype"></div> */}
                </div>
              ) : (
                ""
              )}
              {search.map((listdata) => {
                let list = listdata._source;
                return (
                  <li>
                    <Link
                      className="ctmref"
                      to={"/fiche-avocats/"+ decodedStringValue(list.cbvilleLowerCase)+"/" + list.avocats_id}
                    >
                      {decodedStringValue(list.cbRaisonSociale)} ({list.cbCp}, {decodedStringValue(list.cbVille)} )
                      {
                          list.partner_status ==="approved"?
                          <span style={{ color: "green", marginLeft: "8px" }}><VerifiedIcon color="success" /></span>
                          : list.partner_status ==="gold" ?<span style={{ color: "green", marginLeft: "8px" }}><VerifiedIcon style={{"color":"gold"}}  /></span>:""
                         }
                    </Link>
                  </li>
                );
              })}
              <li className={search.length>0?"":"hidden"} style={{"fontWeight":"700"}}>
                <Link
                  onClick={(e)=>{
                    setCheckList(false)
                    setPaginateData({
                      "current": 1,
                      "total_pages": 0,
                      "total_results": 0,
                      "size": 100
                    })
                  }}
                  className="ctmref"
                  // to={`/directory_search_result/avocats/${searchKey}`}
                  to={`/annuaire-des-avocats-selection/${"avocats"}/${searchKey}`}
                >
                  {"Voir tous les résultats de la recherche"}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="max-w-[800] pb-6 m-auto">
          <div className="flex items-center justify-center w-full gap-2">
            <div className="h-[0.5px] bg-[#DEE3E2] block w-full"> </div>
            <p
              className=" font-medium text-lg text-primary min-w-[120px] m-auto text-center cursor-pointer"
              onClick={onClick}
            >
              {" "}
              + de critères
            </p>
            <div className="h-[0.5px] bg-[#DEE3E2] block w-full"> </div>
          </div>
          {deCriteres ? (
            <div className="flex sm:items-center flex-wrap sm:justify-center gap-2 sm:gap-6 mt-5 transition-all duration-300">
              <FormControl sx={{ m: 1 ,width:"150px" }}>
                <InputLabel id="demo-multiple-checkbox-label">Domaines</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  name="domaines"
                  value={selectedFilterData.domaines}
                  onChange={handleChange}
                  input={<OutlinedInput label="Domaines" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                >
                  {filterData.domaines.map((name) => (
                    <MenuItem key={name.value} value={name.value}>
                      <Checkbox checked={selectedFilterData.domaines.indexOf(name.value) > -1}  />
                      <ListItemText primary={name.value} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1  ,width:"200px"}}>
                <InputLabel id="demo-multiple-checkbox-label">Spécialisations</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  name="specialisations"
                  value={selectedFilterData.specialisations}
                  onChange={handleChange}
                  input={<OutlinedInput label="Spécialisations" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                >
                 {filterData.specialisations.map((name) => (
                    <MenuItem key={name.value} value={name.value}>
                      <Checkbox checked={selectedFilterData.specialisations.indexOf(name.value) > -1}  />
                      <ListItemText primary={name.value} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1 ,width:"150px" }}>
                <InputLabel id="demo-multiple-checkbox-label">Langues</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  name="langues"
                  value={selectedFilterData.langues}
                  onChange={handleChange}
                  input={<OutlinedInput label="Langues" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                >
                  {filterData.langues.map((name) => (
                    <MenuItem key={name.value} value={name.value}>
                      <Checkbox checked={selectedFilterData.langues.indexOf(name.value) > -1}  />
                      <ListItemText primary={name.value} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1  ,width:"150px"}}>
                <InputLabel id="demo-multiple-checkbox-label">Accessibilités</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={selectedFilterData.accessibilites}
                  name="accessibilites"
                  onChange={handleChange}
                  input={<OutlinedInput label="Accessibilités" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                >
                  {filterData.accessibilites.map((name) => (
                    <MenuItem key={name.value} value={name.value}>
                      <Checkbox  checked={selectedFilterData.accessibilites.indexOf(name.value) > -1} />
                      <ListItemText primary={name.value} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* <button className="text-lg font-light text-primary py-2 px-2 sm:px-5 border rounded-md border-primary hover:bg-secondary hover:border-secondary hover:text-white">
                Domaines
              </button>
              <button className="text-lg font-light text-primary py-2 px-2 sm:px-5 border rounded-md border-primary  hover:bg-secondary hover:border-secondary hover:text-white">
                Spécialisations
              </button>
              <button className="text-lg font-light text-primary py-2 px-2 sm:px-5 border rounded-md border-primary  hover:bg-secondary hover:border-secondary hover:text-white">
                Langues
              </button>
              <button className="text-lg font-light text-primary py-2 px-2 sm:px-5 border rounded-md border-primary  hover:bg-secondary hover:border-secondary hover:text-white">
                Accessibilités
              </button> */}
              
            </div>
          ) : null}
        </div>
      </div>
      <div className="w-full bg-mainBg ">
        <div className="grid grid-cols-12 ">
          <div className="col-span-12 lg:col-span-6 3xl:col-span-6 px-4 py-10 h-screen  overflow-auto">
            <h5 className="text-lg font-normal text-primary">
              <span className="font-semibold">({paginateData.total_results})</span> Résultat
              pour avocats{" "}
              <span className="font-semibold">{postalCode}</span>
            </h5>
            {/* ============================================== */}
            {/* ============================================== */}
            
            {/* ====================================================== */}
            <Items currentItems={currentItems} />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: " center",
              }}
            >
              <ReactPaginate
                nextLabel="next"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="previous"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
              />
            </div>
            {/* <nav
              aria-label="Page navigation example"
              className="mt-8 mx-auto w-full flex items-center justify-between"
            >
              <Link
                to=""
                className="flex items-center justify-center gap-2 text-xs sm:text-base font-medium text-gary bg-white py-2 px-3 rounded-md hover:bg-primary hover:text-white"
                style={{ boxShadow: "(0px 4px 2px rgba(240, 240, 240, 0.25)" }}
              >
                <IoIosArrowBack /> Précédent
              </Link>
              <ul className="inline-flex  space-x-3">
                <li>
                  <Link
                    to=""
                    className="text-base font-medium w-9 h-9 rounded-md flex items-center justify-center bg-primary text-white"
                  >
                    1
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    className="text-base font-medium w-9 h-9 bg-white rounded-md flex items-center justify-center text-primary hover:bg-primary hover:text-white"
                  >
                    2
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    className="text-base font-medium w-9 h-9 bg-white rounded-md flex items-center justify-center text-primary hover:bg-primary hover:text-white"
                  >
                    3
                  </Link>
                </li>
                <li className="hidden sm:block">
                  <Link
                    to=""
                    className="text-base font-medium w-9 h-9 bg-white rounded-md flex items-center justify-center text-primary hover:bg-primary hover:text-white"
                  >
                    4
                  </Link>
                </li>
              </ul>
              <Link
                to=""
                className="flex items-center justify-center gap-2 text-xs sm:text-base font-medium text-gary bg-white py-2 px-3 rounded-md hover:bg-primary hover:text-white"
                style={{ boxShadow: "(0px 4px 2px rgba(240, 240, 240, 0.25)" }}
              >
                Suivant
                <IoIosArrowForward />{" "}
              </Link>
            </nav> */}
          </div>
          <div className="col-span-12 lg:col-span-6 3xl:col-span-6">
            {/* <img src={mapDemo} alt="mapDemo" className='h-screen w-full' /> */}
            <Mapbox  geoJson={geoJson} latitude={latlng.latitude} longitude={latlng.longitude} />
            {/* <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5666151.454104781!2d-3.2305647495523675!3d46.09744499642553!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd54a02933785731%3A0x6bfd3f96c747d9f7!2sFrance!5e0!3m2!1sen!2sin!4v1685359635891!5m2!1sen!2sin"
              style={{ width: "100%", height: "100%", minHeight: "785px" }}
              title="france"
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}